import React from 'react';
import { Link } from 'gatsby';
import Toggle from './use-dark-mode';

const Header = () => {
    return (<div className="header">
        <Link to="/" className="header-text"><div >Code Notes</div></Link>
        <div className="toggle"><Toggle /></div>
    </div>)
}

export default Header;